import { useAuth } from '@zep/auth';
import { getGeoInfoFromTimeZone } from '@zep/utils';

import type { PriceLocale } from '../../../plan-payment';

export const usePricingLocale = (): PriceLocale => {
  const { user } = useAuth();
  const countryCode = user?.countryCode?.trim().toUpperCase();

  if (countryCode) {
    return countryCode === 'KR' ? 'ko' : 'en';
  }

  return getGeoInfoFromTimeZone().city === 'Seoul' ? 'ko' : 'en';
};
